"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNKNOWN_ERROR = exports.INTERNAL_ERROR_MESSAGES = exports.ERROR_MESSAGE_TOKEN_PATTERN = void 0;
const ERROR_MESSAGE_TOKEN_PATTERN = exports.ERROR_MESSAGE_TOKEN_PATTERN = /\{(\d+)\}/gu;

/**
 * Code for an unknown error. You should never use nor encounter this error code.
 */
const UNKNOWN_ERROR = exports.UNKNOWN_ERROR = 'UNKNOWN_ERROR';
const INTERNAL_ERROR_MESSAGES = exports.INTERNAL_ERROR_MESSAGES = {
  [UNKNOWN_ERROR]: 'An unknown error has occurred.'
};
//# sourceMappingURL=constants.js.map